export default __webpack_public_path__ + "static/media/Power_Magorzata Szmigiel_Drzew o genealogiczne zrobione PDF.94912e29.pdf";